import type { ResourcesConfig } from "aws-amplify";

const cognitoApiUrl = import.meta.env.VITE_COGNITO_API;
const cognitoClientId = import.meta.env.VITE_COGNITO_CLIENT_ID;
const cognitoUserPoolId = import.meta.env.VITE_COGNITO_USER_POOL_ID;
const cognitoUserPoolEndpoint = import.meta.env.VITE_COGNITO_USERPOOL_ENDPOINT;

export default {
  Auth: {
    Cognito: {
      userPoolId: cognitoUserPoolId,
      userPoolClientId: cognitoClientId,
      userPoolEndpoint: cognitoUserPoolEndpoint,
      loginWith: {
        email: true,
        oauth: {
          providers: ["Google"],
          domain: cognitoApiUrl?.replace("https://", ""),
          redirectSignIn: [`${window.location.origin}/login`],
          redirectSignOut: [`${window.location.origin}/login`],
          responseType: "code",
          scopes: ["openid", "email"],
        },
      },
    },
  },
} satisfies ResourcesConfig;
